// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--1oqIT","fineprint":"faq-module--fineprint--2Ir1p"};